<template>
  <div>
    <div class="flex flex-wrap gap-1 mb-2">
      <span
        v-for="(tag, i) in modelValue"
        :key="tag"
        class="inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded bg-gray-100 text-gray-600"
      >
        {{ tag }}
        <button
          v-if="!readonly"
          type="button"
          class="text-gray-400 hover:text-gray-700 leading-none"
          :aria-label="`Remove tag ${tag}`"
          @click="removeTag(i)"
        >×</button>
      </span>
    </div>
    <input
      v-if="!readonly"
      v-model="tagInput"
      class="w-full border border-gray-300 rounded px-3 py-2 text-sm"
      placeholder="Add tag and press Enter..."
      @keydown.enter.prevent="addTag"
    />
  </div>
</template>

<script>
export default {
  name: 'Support_TagEditor',
  props: {
    modelValue: { type: Array, default: () => [] },
    readonly: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  data() {
    return { tagInput: '' };
  },
  methods: {
    addTag() {
      const tag = this.tagInput.trim();
      if (!tag || this.modelValue.includes(tag)) return;
      this.$emit('update:modelValue', [...this.modelValue, tag]);
      this.tagInput = '';
    },
    removeTag(index) {
      const next = [...this.modelValue];
      next.splice(index, 1);
      this.$emit('update:modelValue', next);
    },
  },
};
</script>
